"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfEmploymentContractDto = instanceOfEmploymentContractDto;
exports.EmploymentContractDtoFromJSON = EmploymentContractDtoFromJSON;
exports.EmploymentContractDtoFromJSONTyped = EmploymentContractDtoFromJSONTyped;
exports.EmploymentContractDtoToJSON = EmploymentContractDtoToJSON;
exports.EmploymentContractDtoToJSONTyped = EmploymentContractDtoToJSONTyped;
/**
 * Check if a given object implements the EmploymentContractDto interface.
 */
function instanceOfEmploymentContractDto(value) {
    if (!('contract' in value) || value['contract'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('signedAt' in value) || value['signedAt'] === undefined)
        return false;
    if (!('signature' in value) || value['signature'] === undefined)
        return false;
    return true;
}
function EmploymentContractDtoFromJSON(json) {
    return EmploymentContractDtoFromJSONTyped(json, false);
}
function EmploymentContractDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'contract': json['contract'],
        'createdAt': (json['createdAt'] == null ? null : new Date(json['createdAt'])),
        'signedAt': (json['signedAt'] == null ? null : new Date(json['signedAt'])),
        'signature': json['signature'],
    };
}
function EmploymentContractDtoToJSON(json) {
    return EmploymentContractDtoToJSONTyped(json, false);
}
function EmploymentContractDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'contract': value['contract'],
        'createdAt': (value['createdAt'] == null ? null : value['createdAt'].toISOString()),
        'signedAt': (value['signedAt'] == null ? null : value['signedAt'].toISOString()),
        'signature': value['signature'],
    };
}
//# sourceMappingURL=EmploymentContractDto.js.map